(() => {
  function initialize(root) {
    if (!root || root.dataset.popsReady) return;
    root.dataset.popsReady = 'true';
    const cards = [...root.querySelectorAll('[data-pops-product]')];
    const featured = ['fanta-white-peach-can-500ml-japan','doritos-coriander-45g-taiwan','skittles-desserts-152g-uk','carne-seca-fuego-blue-beef-jerky-1-7-oz','slo-moe-soda-tech-red','exotic-oreo-cocoa-crisp-roll-guava-green-grape','hello-kitty-bbq-chips','fanta-shine-muscat-can-500ml-japan'];
    const rank = card => featured.includes(card.dataset.handle) ? featured.indexOf(card.dataset.handle) : 999;
    cards.sort((a,b) => rank(a)-rank(b));
    const grid = root.querySelector('[data-pops-grid]');
    cards.forEach(card => grid.appendChild(card));
    let category = new URLSearchParams(location.search).get('pops_category') || 'All';
    if (!['All','Sodas','Snacks','Candy','Merch'].includes(category)) category = 'All';
    let query = '', limit = 8;
    const more = root.querySelector('[data-pops-more]');
    function render() {
      const matches = cards.filter(card => (category === 'All' || card.dataset.category === category) && card.dataset.title.includes(query));
      const shown = new Set(matches.slice(0,limit));
      cards.forEach(card => { card.hidden = !shown.has(card); });
      root.querySelector('[data-pops-count]').textContent = `${matches.length} finds${category === 'All' ? '' : ' · '+category}`;
      root.querySelector('[data-pops-empty]').hidden = matches.length > 0;
      more.hidden = matches.length <= limit;
      root.querySelectorAll('[data-pops-filter]').forEach(button => {
        const active = button.dataset.popsFilter === category;
        button.classList.toggle('px-active',active);
        button.setAttribute('aria-pressed',String(active));
      });
    }
    root.querySelectorAll('[data-pops-filter]').forEach(button => button.addEventListener('click',() => {category=button.dataset.popsFilter;limit=8;render();}));
    document.querySelectorAll('[data-pops-nav]').forEach(link => {
      if(link.dataset.popsBound) return;
      link.dataset.popsBound='true';
      link.addEventListener('click',event => {
        const currentRoot=document.querySelector('[data-pops-storefront]');
        if(!currentRoot) return;
        event.preventDefault();
        currentRoot.dispatchEvent(new CustomEvent('pops:category',{detail:link.dataset.popsNav}));
        currentRoot.querySelector('#pops-shop')?.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      });
    });
    root.addEventListener('pops:category',event=>{category=event.detail;limit=8;render();});
    root.querySelector('[data-pops-search]').addEventListener('input',event=>{query=event.target.value.toLowerCase().trim();limit=8;render();});
    more.addEventListener('click',()=>{limit+=12;render();});
    render();
  }
  document.querySelectorAll('[data-pops-storefront]').forEach(initialize);
  if(!window.popsSectionListener){document.addEventListener('shopify:section:load',event=>initialize(event.target.querySelector('[data-pops-storefront]')));window.popsSectionListener=true;}
})();
